export const loadCacheFromLocalStorage = (cacheKey) => {
  if (!localStorage.getItem(cacheKey)) return null;

  try {
    const cacheItem = JSON.parse(localStorage.getItem(cacheKey));
    return cacheItem.data;
  } catch {
    console.log(`Issue with Kendo grid cache: ${cacheKey}`);
    localStorage.removeItem(cacheKey);
    return null;
  }
};

export const saveCacheToLocalStorage = (cacheKey, data) => {
  const cacheItem = {
    data
  };

  try {
    localStorage.setItem(cacheKey, JSON.stringify(cacheItem));
  } catch (error) {
    if (error.name === 'QuotaExceededError' || error.code === 22) {
      console.warn(`localStorage quota exceeded for key: ${cacheKey}. Clearing old kendo cache entries.`);
      clearKendoCacheEntries();
      try {
        localStorage.setItem(cacheKey, JSON.stringify(cacheItem));
      } catch (retryError) {
        console.warn(`Failed to save cache even after clearing: ${cacheKey}`);
      }
    } else {
      console.warn(`Failed to save to localStorage: ${cacheKey}`, error);
    }
  }
};

const clearKendoCacheEntries = () => {
  const keysToRemove = Object.keys(localStorage).filter((key) => key.startsWith('kendo/'));
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};

export const toRestoreGridPage = () => {
  return String(window.performance.getEntriesByType('navigation')[0].type) === 'back_forward';
};
